import React from 'react'
import { Box } from '@smooth-ui/core-em'
import { css } from 'react-emotion'

const BoxCustom = props => {
  const { debug, flexGrow, ...other } = props
  const border = debug ? '1px dotted blue' : ''

  let classNames = ''
  if (flexGrow) {
    classNames = css({
      flexGrow: props.flexGrow,
    })
  }

  return (
    <Box className={classNames} border={border} {...other}>
      {props.children}
    </Box>
  )
}

export default BoxCustom



// WEBPACK FOOTER //
// ./src/UILibrary/Box.js